// src/Pages/ScientificOutputs.js

import './ScientificOutputs.css';
import Header from '../Assets/Components/Header.js';
import Footer from '../Assets/Components/Footer.js';

// Importing output images
import Cover2019 from '../Assets/Images/meshroom_point_cloud.webp';
import CoverThesis from '../Assets/Images/articlesCovers/coverWrapping_rebuild.png';
import Cover20174 from '../Assets/Images/articlesCovers/intertidal_lanice_patches.jpg';
import Cover20172 from '../Assets/Images/articlesCovers/submerged_lanice.jpg';
import Cover2014 from '../Assets/Images/qgis_slope.webp';


// Blog list with link and representative photos
const science = [
  {
    text: 'Alves et al (2019). Cost-Effective Coastal Habitat Mapping: Detecting Intertidal Polychaete Aggregations with Low-Altitude Photogrammetry.',
    image: Cover2019,
    url: 'https://doi.org/10.14358/pers.85.12.899',
  },
  {
    text: 'Alves, RMS (2017). Spatial structure and temporal dynamics of an intertidal population of the marine ecosystem engineering worm Lanice conchilega (pallas, 1766). PhD Thesis.',
    image: CoverThesis,
    url: 'http://hdl.handle.net/1854/LU-8544280',
  },
  {
    text: 'Alves et al (2017). A case study on the growth of Lanice conchilega (Pallas, 1766) aggregations and their ecosystem engineering impact on sedimentary processes.',
    image: Cover20174,
    url: 'https://doi.org/10.1016/j.jembe.2017.01.005',
  },
  {
    text: 'Alves et al (2017). Effects of temporal fluctuation in population processes of intertidal Lanice conchilega (Pallas, 1766) aggregations on its ecosystem engineering.',
    image: Cover20172,
    url: 'https://doi.org/10.1016/j.ecss.2017.02.012',
  },
  {
    text: 'Lins et al (2014). The link between meiofauna and surface productivity in the Southern Ocean.',
    image: Cover2014,
    url: 'https://doi.org/10.1016/j.dsr2.2014.05.003',
  }
];


// Rendering blog page
const ScientificOutputs = () => {
  return (
    <div className='sciouts-page'>
        <Header />

        <div className='sciouts-main-content'>
            <div className='sciouts-page-title'><h1>Academic Outputs</h1>
            <div className='sciouts-page-legend'>All images by <a className='sciouts-page-legend-link' href='https://orcid.org/0000-0002-8422-0611'> Renata M. S. Alves, PhD</a>.</div>
            </div>

            <div className='sciouts-grid'>
                {science.map((science, index) => (
                    <div className='sciouts-box' title={science.text} key={index}>
                        <a className='sciouts-link' href={science.url} target='_blank' rel='noopener noreferrer'>
                            <div className='sciouts-box-top' style={{ '--bg-url': `url(${science.image})` }}>
                            </div>
                            <div className='sciouts-box-bottom'>
                                <p>{science.text}</p>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
      
        <Footer />
    </div>
  );
};

export default ScientificOutputs;